import { ChevronRight, Star } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Hero = () => {
  const { t } = useLang();
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden grain" data-testid="hero-section">
      <img
        src="https://images.unsplash.com/photo-1743697706311-120044ecaf22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxjYW5jdW4lMjB0dXJxdW9pc2UlMjBvY2VhbiUyMGJlYWNofGVufDB8fHx8MTc4MTcyNjgxNHww&ixlib=rb-4.1.0&q=85"
        alt="Cancún beach"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-jungle/90 via-jungle/60 to-jungle/20" />

      <div className="relative z-10 px-6 md:px-12 lg:px-20 mx-auto max-w-7xl w-full pt-28 pb-16">
        <div className="max-w-2xl">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-teal font-bold mb-5 fade-up" data-testid="hero-overline">
            {t.hero.overline}
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-semibold text-sand leading-[1.05] mb-6 fade-up" style={{ animationDelay: "0.1s" }}>
            {t.hero.title}
          </h1>
          <p className="font-body text-base sm:text-lg text-sand/85 leading-relaxed mb-9 max-w-xl fade-up" style={{ animationDelay: "0.2s" }}>
            {t.hero.subtitle}
          </p>

          <div className="flex flex-wrap gap-4 mb-14 fade-up" style={{ animationDelay: "0.3s" }}>
            <button
              onClick={() => go("#book")}
              data-testid="hero-book-button"
              className="group inline-flex items-center gap-2 bg-teal text-sand hover:bg-teal-dark font-body px-8 py-4 transition-colors"
            >
              {t.hero.cta}
              <ChevronRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => go("#pricing")}
              data-testid="hero-pricing-button"
              className="inline-flex items-center gap-2 border border-sand/40 text-sand hover:bg-sand hover:text-jungle font-body px-8 py-4 transition-colors"
            >
              {t.hero.ctaSecondary}
            </button>
          </div>

          <div className="flex gap-10 fade-up" style={{ animationDelay: "0.4s" }}>
            {[
              [t.hero.stat1v, t.hero.stat1],
              [t.hero.stat2v, t.hero.stat2],
              [t.hero.stat3v, t.hero.stat3],
            ].map(([v, l], i) => (
              <div key={i} data-testid={`hero-stat-${i}`}>
                <div className="font-heading text-3xl font-semibold text-sand flex items-center gap-1">
                  {i === 1 && <Star size={18} className="text-teal fill-teal" />}
                  {v}
                </div>
                <div className="font-body text-xs uppercase tracking-wider text-sand/60 mt-1">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
